module.exports = __webpack_public_path__ + "img/home-7.5aa403a7.webp";